export default "__VITE_ASSET__DmROaN94__"